export const normalizePathname = pathname => {
	let pathnames = pathname.split('/');

	if (pathnames[0] !== '') {
		pathnames = ['', ...pathnames];
	}

	return pathnames;
};



// WEBPACK FOOTER //
// ./src/util/path.js